import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { routes } from 'routes/routes';

export const useOnNavigateToProfile = () => {
  const navigate = useNavigate();

  return useCallback(
    async (id: string) => {
      await navigate(routes.members.detail(id));
    },
    [navigate],
  );
};
